import { ApiErrorWithStack } from "./types";

export interface ErrorInfo {
  message: string;
  traceId: string | null;
}

export function extractErrorInfo(error: unknown): ErrorInfo {
  if (error instanceof ApiErrorWithStack) {
    return {
      message: error.message,
      traceId: error.traceId || null,
    };
  }
  
  if (error instanceof Error) {
    return {
      message: error.message,
      traceId: null,
    };
  }
  
  return {
    message: String(error),
    traceId: null,
  };
}
